import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'

import { accountLanguagesService } from 'src/services/account-languages.service'

import { QUERY_KEYS } from 'src/constants'
import { IUpdateAccountLanguagesDto } from 'src/types'

export const useUpdateAccountLanguages = () => {
  const { accountId } = useParams()
  const queryClient = useQueryClient()

  return useMutation(
    async (dto: IUpdateAccountLanguagesDto) =>
      accountId ? accountLanguagesService.updateAccountLanguages(accountId, dto) : null,
    {
      onSuccess(data, vars) {
        if (!data) return

        queryClient.setQueryData([QUERY_KEYS.ACCCOUNT_LANGUAGES_IDS, accountId], vars.languagesIds)
      },
    },
  )
}
